<template>
  <v-row>
    <v-col cols="6">
    <v-autocomplete
      :loading="loading"
      :items="items"
      item-text="code_name"
      item-value="id"
      :search-input.sync="search"
      v-model="sid"
      class="mx-3"
      cache-items
      dense
      solo
      hide-no-data
      hide-details
      label="釜票"
      >
    </v-autocomplete>
    </v-col>
    <v-col cols="6">
      <div style="text-align:right;font-size:12px;">{{ intro }}</div>
    </v-col>
  </v-row>
</template>

<style>
</style>

<script>
import { getFormulaList, getFormula } from '@/api/formula'

export default {
  name: 'FormulaSel',
  data () {
    return {
      loading: false,
      items: [],
      search: null,
      sid: null,
      intro: '',
      weight: 0,
      pd_time: 0
    }
  },
  watch: {
    search (val) {
      val && this.qrySelections(val)
    },
    sid (val) {
      this.items.some(e => {
        if (e.id === val) {
          if (e.weight) {
            this.weight = e.weight
            this.pd_time = e.pd_time
            this.intro = '单位重量:' + e.weight + 'kg, 生产时间:' + e.pd_time + '分钟'
          }
          this.$emit('change', val)
          return true
        }
        return false
      })
    }
  },
  methods: {
    setVal (id, txt) {
      if (id <= 0) return
      getFormula(id).then(res => {
        this.items = [
          {
            'id': id,
            'code_name': res.data.code + ' - ' + res.data.name,
            'weight': res.data.weight,
            'pd_time': res.data.pd_time
          }
        ]
        this.sid = id
      })
    },
    getVal () {
      return this.sid
    },
    qrySelections (v) {
      this.loading = true
      let d = {
        'kw': v,
        'page': 1,
        'perPage': 9999
      }
      getFormulaList(d).then(res => {
        this.loading = false
        this.items = res.data.items
        this.items.forEach(e => {
          e.code_name = e.code + ' - ' + e.name
        })
      })
    }
  },
  mounted () {
  }
}
</script>
